import type { AppErrorTranslations } from "../utils/types"

import de from "./error/de.json"
import en from "./error/en.json"
import fr from "./error/fr.json"
import it from "./error/it.json"

export const errorTranslations: AppErrorTranslations = {
  de,
  en,
  fr,
  it
}
